var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-licences"},[(_vm.chargingPoint)?_c('charging-point-profile-card',{attrs:{"charging-point":_vm.chargingPoint},on:{"changed":_vm.reload}}):_vm._e(),_c('subscription-licences-list',{key:_vm.reloads,attrs:{"charging-point-id":_vm.chargingPoint.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }